import { Navigate, useParams } from "react-router-dom";
import { PublicCycleProvider } from "@/context/PublicCycleContext";
import { PublicJoinEntry } from "@/pages/v2/PublicHomePage";

const PublicJoinPage = () => {
  const { token } = useParams<{ token: string }>();

  if (!token) {
    return <Navigate to="/" replace />;
  }

  return (
    <PublicCycleProvider token={token}>
      <PublicJoinEntry />
    </PublicCycleProvider>
  );
};

export default PublicJoinPage;
